import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { Page as Component } from "~/components/specifics/vendors/settings/accounts/Page";

export function Page() {
	return (
		<VendorLayoutV2>
			<Component />
		</VendorLayoutV2>
	);
}
